export const checkReadOnlyUser = user => {
  if (
    user.readOnlyClients &&
    user.preferences &&
    user.preferences.selectedClient &&
    user.readOnlyClients.includes(user.preferences.selectedClient.name)
  ) {
    return true;
  }
  return false;
};
